import { Badge } from '../../ui/badge';
import { KonumPaylas } from '../../maps/KonumPaylas';
import { Section, Field, grid } from '../bakim-onarim/DetayParcalari';
import {
  KONUM_KIND, konumMetni, emlakBaslik, temelSatirlari, konumSatirlari, mulkiyetSatirlari,
  kamulastirmaSatirlari, depremYanginSatirlari, kayitSatirlari,
} from './emlakOrtak';

// [etiket, değer, stil] satırlarını grid alanlarına çevirir; stil varsa değer rozet olur
export function Satirlar({ rows, prefix }) {
  return (
    <div className={grid}>
      {rows.map(([label, value, stil]) => {
        const testId = `${prefix}-${label.toLocaleLowerCase('tr').replace(/[^a-z0-9ğüşöçı]+/g, '-')}`;
        if (stil && value) {
          return (
            <div key={label} data-testid={testId}>
              <span className="text-gray-500">{label}:</span>
              <Badge className={`ml-2 border ${stil.tone}`}>{value}</Badge>
            </div>
          );
        }
        return <Field key={label} label={label} value={value} testId={testId} className={String(value || '').length > 60 ? 'col-span-2 md:col-span-3' : ''} />;
      })}
    </div>
  );
}

export function TemelBilgiler({ emlak, no }) {
  return (
    <Section no={no} title="Taşınmaz Türü ve Tesis Bilgileri" testId="emlak-detail-section-temel">
      <Satirlar rows={temelSatirlari(emlak)} prefix="emlak-detail" />
    </Section>
  );
}

function Harita({ emlak, geo }) {
  const kind = geo ? KONUM_KIND[geo.kind] : null;
  return (
    <div className="mt-3 rounded-lg overflow-hidden border border-gray-700 bg-gray-800/40" data-testid="emlak-map-container">
      <div className="relative h-[230px] bg-gray-900">
        {geo ? (
          <iframe
            title="Konum Haritası" width="100%" height="230" frameBorder="0" scrolling="no" style={{ border: 0 }}
            src={`https://www.openstreetmap.org/export/embed.html?bbox=${geo.lon - kind.span},${geo.lat - kind.span * 0.6},${geo.lon + kind.span},${geo.lat + kind.span * 0.6}&layer=mapnik&marker=${geo.lat},${geo.lon}`}
            data-testid="emlak-map-iframe"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-xs text-gray-500">Konum yükleniyor…</div>
        )}
        <div className="absolute bottom-2 left-2 bg-gray-900/85 backdrop-blur-sm rounded px-2 py-1 text-[10px] text-gray-300">
          {konumMetni(emlak)}
          {kind && <span className={`ml-1 ${kind.tone}`} data-testid="emlak-map-precision">· {kind.text}</span>}
        </div>
        {geo && (
          <a href={`https://www.google.com/maps?q=${geo.lat},${geo.lon}`} target="_blank" rel="noopener noreferrer"
            className="absolute top-2 right-2 bg-gray-900/85 backdrop-blur-sm rounded px-2 py-1 text-[10px] text-blue-300 hover:text-blue-200" data-testid="emlak-map-gmaps-link">
            Google Maps'te aç →
          </a>
        )}
      </div>
      {geo && (
        <div className="px-3 pb-3 pt-1">
          <KonumPaylas compact testIdPrefix="emlak-detail"
            item={{ lat: geo.lat, lon: geo.lon, approx: geo.kind !== 'kayit', name: emlakBaslik(emlak), district: [emlak.mahalle, emlak.ilce].filter(Boolean).join(', ') }} />
        </div>
      )}
    </div>
  );
}

export function KonumKadastro({ emlak, geo, no }) {
  return (
    <Section no={no} title="Konum ve Kadastro" testId="emlak-detail-section-konum">
      <Satirlar rows={konumSatirlari(emlak)} prefix="emlak-detail" />
      <Harita emlak={emlak} geo={geo} />
    </Section>
  );
}

export function MulkiyetTahsis({ emlak, no }) {
  const kamu = kamulastirmaSatirlari(emlak);
  return (
    <Section no={no} title="Mülkiyet ve Tahsis Bilgileri" testId="emlak-detail-section-mulkiyet">
      <Satirlar rows={mulkiyetSatirlari(emlak)} prefix="emlak-detail" />
      {kamu.length > 0 && (
        <div className="mt-3 p-3 bg-amber-900/15 border border-amber-700/50 rounded-lg" data-testid="emlak-detail-kamulastirma">
          <h4 className="text-amber-300 font-medium text-sm mb-2">Kamulaştırma Bilgileri</h4>
          <Satirlar rows={kamu} prefix="emlak-detail-kamu" />
        </div>
      )}
    </Section>
  );
}

export function DepremYangin({ emlak, no }) {
  return (
    <Section no={no} title="Deprem, Güçlendirme ve Yangın Yönetmeliği" testId="emlak-detail-section-deprem">
      <Satirlar rows={depremYanginSatirlari(emlak)} prefix="emlak-detail" />
    </Section>
  );
}

export function AciklamaKayit({ emlak, no }) {
  return (
    <Section no={no} title="Açıklama ve Kayıt Bilgileri" testId="emlak-detail-section-aciklama">
      <div className="text-sm mb-3" data-testid="emlak-detail-aciklama">
        <span className="text-gray-500">Açıklama:</span>
        <p className="text-gray-300 whitespace-pre-wrap mt-1">{emlak.aciklama || '-'}</p>
      </div>
      <Satirlar rows={kayitSatirlari(emlak)} prefix="emlak-detail-kayit" />
    </Section>
  );
}
